import React from "react";
import { makeStyles } from "tss-react/mui";

import Container from "@mui/material/Container";

import CommonLayout from "../../Common/Layout";
import DetailTable from "./DetailTable";
import ComponentSuspense from "../../Common/ComponentSuspense";
import HelpContextIcon from "../../Common/HelpPanel/HelpContextIcon";
const Metrics = React.lazy(() => import("./Metrics"));

const useStyles = makeStyles()((theme) => ({
  PanelContainer: {
    padding: "10px 30px 30px 30px",
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
}));

const breadcrumbArr = [
  { link: "/reports", displayName: "Reports", active: false },
  { link: "#", displayName: "Data AI Usage", active: true },
];

const DataAIUsage = () => {
  const { classes } = useStyles();

  return (
    <CommonLayout
      title={
        <>
          Data AI Usage
          <HelpContextIcon screen="Data AI Usage" />
        </>
      }
      breadcrumbArr={breadcrumbArr}
    >
      <Container maxWidth="false" sx={{ m: 0 }} className={classes.PanelContainer}>
        <ComponentSuspense>
          <Metrics />
        </ComponentSuspense>
        <DetailTable />
      </Container>
    </CommonLayout>
  );
};

export default DataAIUsage;
